module.exports = __webpack_public_path__ + "img/Logo_Vertical.f915b625.png";